import React from "react";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import { RatingStarIcon } from "@/assets/icons";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

const stars = [1, 2, 3, 4, 5];

export const RatingBlock = () => {
  return (
    <FlexRow gap={8} justifyContent="center">
      <FlexRow gap={3} className={cls.stars}>
        {stars.map((elem) => (
          <RatingStarIcon key={elem} />
        ))}
      </FlexRow>

      <Typography className={cls.rating}>4,8</Typography>

      <Typography className={cls.ratingText}>·</Typography>

      <Typography className={cls.ratingText}>1000+ курьеров</Typography>
    </FlexRow>
  );
};
